<div class="container-fluid">
  <div class="pages_space">
    <div class="row mb-2">
      <div class="col-12 col-sm">
        <!-- search placeholder -->
        <form name="searchClaimsFilterForm" [formGroup]="searchClaimsFilterForm" #formDir="ngForm">
          <div class="row search_section">
            <div class="col col-md-4 col-lg-3 pr-lg-0">
              <input type="text" class="form-control rounded-0" formControlName="keyword" placeholder="Search" />
            </div>
            <div class="col-auto ">
              <div class="k_button_holder">
                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Search'" [color]="'brand-main'"
                  (buttonClick)="submit_searchClaimsFilterForm(searchClaimsFilterForm)">
                </k-button>
                <k-button [type]="KButtonType.KLAiMSButton" [color]="'brand-main'" [icon]="{type: 'fas', name: 'undo'}"
                  (buttonClick)="resetSearchClaimFilterForm(searchClaimsFilterForm)">
                </k-button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-12 col-sm-auto text-end  mt-2 mt-sm-0">
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Create New Claim'" [color]="'brand-main'"
          [icon]="{type: 'fas', name: 'plus'}" (buttonClick)="createNewClaim()">
        </k-button>
      </div>
    </div>
    <div class="row" infiniteScroll [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollUpDistance]="scrollUpDistance" [infiniteScrollThrottle]="throttle" (scrolled)="onScrollDown()">
      <div class="col-12  " *ngIf="this.allCards?.length === 0">
        No data found
      </div>
      <div class="col-md-6 col-lg-4 col-xl-2 col-sm-6 card-col" *ngFor="let card of allCards">
        <k-card [card]="card" (cardEvent)="cardEvent($event, card)"></k-card>
      </div>
    </div>
  </div>
</div>